'use strict';

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.object.define-properties");

require("core-js/modules/es7.object.get-own-property-descriptors");

require("core-js/modules/es6.array.for-each");

require("core-js/modules/es6.array.filter");

require("core-js/modules/es6.symbol");

require("core-js/modules/es6.object.keys");

var _regeneratorRuntime = require("E:/Social/ACJP_Global_Website/stsgit/acjp/node_modules/@babel/runtime/regenerator");

var _slicedToArray = require("E:/Social/ACJP_Global_Website/stsgit/acjp/node_modules/@babel/runtime/helpers/slicedToArray");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

var _toConsumableArray = require("E:/Social/ACJP_Global_Website/stsgit/acjp/node_modules/@babel/runtime/helpers/toConsumableArray");

require("core-js/modules/es6.array.reduce");

var _defineProperty = require("E:/Social/ACJP_Global_Website/stsgit/acjp/node_modules/@babel/runtime/helpers/defineProperty");

require("regenerator-runtime/runtime");

var _asyncToGenerator = require("E:/Social/ACJP_Global_Website/stsgit/acjp/node_modules/@babel/runtime/helpers/asyncToGenerator");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var ky = require('ky-universal')["default"] || require('ky-universal');

var isUrlHttp = require('is-url-http/lightweight');

var _require = require('qss'),
    stringify = _require.encode;

var whoops = require('whoops');

var flatten = require('flat');

var factory = require('./factory');

var MicrolinkError = whoops('MicrolinkError');

var got = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(url, opts) {
    var response, body, headers, statusCode, statusMessage, _response;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            if (opts.timeout === undefined) opts.timeout = false;
            _context.next = 4;
            return ky(url, opts);

          case 4:
            response = _context.sent;
            _context.next = 7;
            return response.json();

          case 7:
            body = _context.sent;
            headers = response.headers, statusCode = response.status, statusMessage = response.statusText;
            return _context.abrupt("return", {
              url: response.url,
              body: body,
              headers: headers,
              statusCode: statusCode,
              statusMessage: statusMessage
            });

          case 12:
            _context.prev = 12;
            _context.t0 = _context["catch"](0);

            if (!_context.t0.response) {
              _context.next = 26;
              break;
            }

            _response = _context.t0.response;
            _context.t1 = _objectSpread;
            _context.t2 = _objectSpread({}, _response);
            _context.t3 = {};
            _context.t4 = _toConsumableArray(_response.headers.entries()).reduce(function (acc, _ref2) {
              var _ref3 = _slicedToArray(_ref2, 2),
                  key = _ref3[0],
                  value = _ref3[1];

              return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, key, value));
            }, {});
            _context.t5 = _response.status;
            _context.next = 23;
            return _response.text();

          case 23:
            _context.t6 = _context.sent;
            _context.t7 = {
              headers: _context.t4,
              statusCode: _context.t5,
              body: _context.t6
            };
            _context.t0.response = (0, _context.t1)(_context.t2, _context.t3, _context.t7);

          case 26:
            throw _context.t0;

          case 27:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 12]]);
  }));

  return function got(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();

module.exports = factory({
  MicrolinkError: MicrolinkError,
  isUrlHttp: isUrlHttp,
  stringify: stringify,
  got: got,
  flatten: flatten,
  VERSION: '__VERSION__'
});